import { render, staticRenderFns } from "./ScoringDialogComponent.vue?vue&type=template&id=1875b287&scoped=true"
import script from "./ScoringDialogComponent.js?vue&type=script&lang=js&external"
export * from "./ScoringDialogComponent.js?vue&type=script&lang=js&external"
import style0 from "./ScoringDialogComponent.vue?vue&type=style&index=0&id=1875b287&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1875b287",
  null
  
)

export default component.exports